export const ENLARGED_IMAGE_POSITION = {
  over: 'over',
  beside: 'beside'
};

export const FADE_DURATION_IN_MS = 300;